import { BottomSheetModalMethods } from '@gorhom/bottom-sheet/lib/typescript/types'
import React, { RefObject, createContext, useContext } from 'react'

const InfoModalContext = createContext<RefObject<BottomSheetModalMethods> | null>(null)

type InfoModalProviderProps = {
  infoModalRef: RefObject<BottomSheetModalMethods>
  children: React.ReactNode
}

const InfoModalProvider = ({ infoModalRef, children }: InfoModalProviderProps) => {
  return <InfoModalContext.Provider value={infoModalRef}>{children}</InfoModalContext.Provider>
}

const useInfoModal = () => {
  return useContext(InfoModalContext)
}

export { InfoModalProvider, useInfoModal }
